import { useQuery } from "@tanstack/vue-query";
import { MaybeRefOrGetter, toValue } from "vue";

import KiliApi from "@/data/api/kili/kili-api";
import { SectionsQueryKeys } from "@/data/api/kili/sections/sections-query-keys";

export function useGetSectionAppliancesQuery(siteId: MaybeRefOrGetter<number>, sectionId: MaybeRefOrGetter<number>) {
  return useQuery({
    queryKey: SectionsQueryKeys.appliance(siteId, sectionId),
    queryFn: async () => KiliApi.getSectionAppliances({ params: { sectionId: toValue(sectionId) } }),
  });
}
